module.exports = __webpack_public_path__ + "static/media/oneColumn.3393d1e5.svg";